import HistoryLayout from '@/routes/account/layout/HistoryLayout';
import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

interface AccountDetailsProps {}

const AccountDetails: FC<AccountDetailsProps> = () => {
  return (
    <HistoryLayout bookingType="accountDetails">
      <Outlet />
    </HistoryLayout>
  );
};

export default AccountDetails;
